import { LayoutJustino, styled } from "@lux/ds";

export const StyledLayoutJustino = styled(LayoutJustino)`
  align-items: center;
  pointer-events: none;
`;
